import React, { memo } from 'react';

interface FormFieldProps {
  id?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  placeholder?: string;
  error?: string;
  required?: boolean;
}

function FormField({ 
  id,
  label, 
  value, 
  onChange, 
  type = 'text', 
  placeholder = '',
  error,
  required = false
}: FormFieldProps) {
  const fieldId = id || `field-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div className="relative">
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`peer w-full px-4 py-2.5 text-sm bg-black/50 border rounded-lg focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 placeholder-transparent text-[#c8c2bd] ${
          error 
            ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
            : 'border-gray-800'
        }`}
        id={fieldId}
        required={required}
      />
      <label
        htmlFor={fieldId}
        className={`absolute z-10 left-2 -top-2.5 px-1 text-xs transition-all 
                  bg-[#111] peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-500 
                  peer-placeholder-shown:top-2.5 peer-placeholder-shown:left-4 
                  peer-focus:-top-2.5 peer-focus:left-2 peer-focus:text-xs ${
                    error 
                      ? 'text-red-500 peer-focus:text-red-400'
                      : 'text-[#c8c2bd] peer-focus:text-indigo-400'
                  }`}
      >
        {label}{required && ' *'}
      </label>
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}

export default memo(FormField);